import api from './api';

// Feature flags da instalação (/api/configuracao/funcionalidades).
//
// Guardadas em localStorage porque a navegação (utils/modulos.jsx) é montada de
// forma síncrona: sem valor em mãos na hora de montar o menu, o módulo opcional
// piscaria na tela e sumiria depois da resposta.
//
// Flag conhecida e desligada esconde o módulo. Flag DESCONHECIDA, num cache já
// carregado, também vale como desligada — assim instalação com back em versão
// anterior não mostra módulo que ele ainda não conhece.
//
// Cache VAZIO é caso diferente, e a distinção passou a importar quando todos os
// módulos ganharam gate: antes da primeira resposta o navegador não sabe nada, e
// tratar "não sei" como "desligado" apagaria a navegação inteira até o GET
// voltar. Enquanto não há resposta, tudo aparece — o back-end continua barrando
// o que não estiver disponível, então o pior caso é um item sumir um instante
// depois, em vez de a tela abrir vazia.
const CHAVE = 'patio.funcionalidades';

let cache = null;

const lerCache = () => {
    if (cache) return cache;
    try {
        cache = JSON.parse(localStorage.getItem(CHAVE) || '{}');
    } catch {
        cache = {};
    }
    return cache;
};

export const perfilGenerico = () => lerCache().perfilGenerico === true;

export const funcionalidadeAtiva = (nome) => {
    const flags = lerCache();
    if (Object.keys(flags).length === 0) return true; // ainda não carregou
    return flags[nome] === true;
};

// Uma busca por carregamento de página. A guarda de rota é reavaliada a cada
// navegação, e sem isto cada troca de tela viraria um GET.
let buscada = null;

// Chamada no boot da área autenticada e depois do login. Falha de rede não
// derruba a tela: mantém o que já havia em cache.
export const carregarFuncionalidades = (forcar = false) => {
    if (buscada && !forcar) return buscada;
    buscada = buscar();
    return buscada;
};

// Evento avisando que as flags mudaram.
//
// A navegação é montada com useMemo de dependência vazia — calculada uma vez
// por montagem. Sem este aviso, ligar uma funcionalidade no MPG Support só
// aparecia no menu depois de recarregar a página, e a impressão era de que o
// botão não fazia nada.
export const EVENTO_FUNCIONALIDADES = 'patio:funcionalidades';

const buscar = async () => {
    const anterior = JSON.stringify(lerCache());
    try {
        const { data } = await api.get('/configuracao/funcionalidades');
        cache = data || {};
        localStorage.setItem(CHAVE, JSON.stringify(cache));
    } catch {
        lerCache();
    }
    // Só avisa quando mudou de fato: o carregamento de rotina acontece a cada
    // navegação, e re-renderizar o menu inteiro à toa é desperdício.
    if (JSON.stringify(cache) !== anterior) {
        window.dispatchEvent(new Event(EVENTO_FUNCIONALIDADES));
    }
    return cache;
};

export const limparFuncionalidades = () => {
    cache = null;
    buscada = null;
    localStorage.removeItem(CHAVE);
};
